
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { AllowedInputTypes, AutocompleteTypes } from '@/entities/rain/input-single-line'

@Component<InputSingleLine>({
    model: {
        prop: 'value',
        event: 'input'
    }
})
export default class InputSingleLine extends Vue {
    @Prop({ type: String, required: false, default: 'text' })
    public readonly type!: AllowedInputTypes
    @Prop({ type: String, required: false, default: 'off' })
    public readonly autocomplete!: AutocompleteTypes
    @Prop({ type: String, required: false, default: '' })
    public readonly value!: string
    @Prop({ type: Boolean, required: false, default: false })
    public readonly disabled!: boolean
    @Prop({ type: Boolean, required: false, default: false })
    public readonly error!: boolean
    @Prop({ type: String, required: false, default: '' })
    public readonly label!: string
}
